import React, { createContext, useCallback, useState } from 'react';

export const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const showLoading = useCallback(() => setLoading(false), []);
  const hideLoading = useCallback(() => setLoading(false), []);


  return (
    <LoaderContext.Provider value={{ loading, showLoading, hideLoading }}>
      {children}
    </LoaderContext.Provider>
  );
};
